import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";
import { VIEWS, viewText } from "@/lib/program";
import { PdfButton, PptButton } from "@/components/program/ExportButtons";

export const MaterialViews = ({ kajian }) => {
  const [view, setView] = useState("kuliah");
  const [copied, setCopied] = useState(false);
  const text = viewText(view, kajian);
  const copy = async () => {
    try { await navigator.clipboard.writeText(text); setCopied(true); toast.success("Disalin"); setTimeout(() => setCopied(false), 1500); }
    catch { toast.error("Gagal menyalin"); }
  };
  return (
    <section className="space-y-4" data-testid="material-views">
      <p className="text-sm text-mute">Bahan disusun terus daripada kerangka program yang sama. Tiada kuota digunakan.</p>
      <div className="flex flex-wrap gap-2">
        {VIEWS.map(([id, label]) => (
          <button key={id} onClick={() => setView(id)} data-testid={`material-tab-${id}`}
            className={`h-9 px-4 rounded-full text-sm border transition-colors ${view === id ? "bg-ink text-bg border-transparent" : "border-line text-mute hover:text-ink"}`}>{label}</button>
        ))}
      </div>
      <div className="surface rounded-2xl border border-line">
        <div className="flex flex-wrap justify-end gap-2 p-3 border-b border-line">
          <PdfButton kajianId={kajian.id} tajuk={VIEWS.find(([id]) => id === view)[1]} teks={text} testid="material-pdf-button" />
          {view === "slaid" && <PptButton kajianId={kajian.id} tajuk={kajian.tajuk} />}
          <button onClick={copy} data-testid="material-copy-button" className="h-9 px-4 rounded-full border border-line text-sm inline-flex items-center gap-2 hover:bg-bg transition-colors">
            {copied ? <Check size={14} className="text-i" /> : <Copy size={14} />} Salin
          </button>
        </div>
        <pre className="p-5 text-sm text-ink whitespace-pre-wrap font-sans leading-relaxed max-h-[70vh] overflow-auto" data-testid={`material-text-${view}`}>{text}</pre>
      </div>
    </section>
  );
};
